import { cn } from "../../lib/cn";

interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** Used as aria-label when no visible label is paired with it. */
  ariaLabel?: string;
  id?: string;
}

export function Switch({ checked, onChange, disabled, ariaLabel, id }: SwitchProps) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative inline-flex h-7 w-12 shrink-0 rounded-full transition-colors",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        checked ? "bg-primary" : "bg-border-strong",
      )}
    >
      <span
        aria-hidden
        className={cn(
          "absolute top-0.5 h-6 w-6 rounded-full bg-white",
          "shadow-[0_1px_2px_rgba(15,23,42,0.18),0_1px_1px_rgba(15,23,42,0.1)]",
          "transition-transform duration-200 ease-out",
          checked ? "translate-x-[22px]" : "translate-x-0.5",
        )}
      />
    </button>
  );
}
